import { render, staticRenderFns } from "./RichHorizontalIndicator.vue?vue&type=template&id=996f5342&scoped=true&"
import script from "./RichHorizontalIndicator.vue?vue&type=script&lang=js&"
export * from "./RichHorizontalIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RichHorizontalIndicator.vue?vue&type=style&index=0&id=996f5342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f5342",
  null
  
)

export default component.exports